export default __webpack_public_path__ + "eefd3e3481c4696e988ceb7d0737e387.svg";